<template>
	<div class="print_container full">
		<div class="print_header flex">
			<el-button type="primary" v-print="printObj" size="mini">打印</el-button>
			<el-button type="success" @click="download" size="mini">下载</el-button>
			<!-- <el-button type="danger" style="position: absolute;right: 10px;" @click="back">返回</el-button> -->
		</div>
		<div class="print full">
			<div class="print_paper">
				<div class="print_content" id="print_content" ref="printContent"
					style="-webkit-print-color-adjust: exact;">
					<div class="header flex">
						<div class="header_title">销售单</div>
						<div class="header_notice">
							<div style="font-weight: bold;">温州纳智紧固件有限公司</div>
							<div style="font-weight: bold;">佛山纳智五金制品有限公司</div>
							<div style="font-size: 12px;">专业生产螺丝、螺母、气动元件；</div>
						</div>
					</div>
					<div class="body">
						<vxe-table border :data="infoData" :merge-cells="mergeCells" size="mini" :show-header="false"
							style="width: 100%;">
							<vxe-column field="a" title=""></vxe-column>
							<vxe-column field="b" title=""></vxe-column>
							<vxe-column field="c" title=""></vxe-column>
							<vxe-column field="d" title=""></vxe-column>
							<vxe-column field="e" title=""></vxe-column>
							<vxe-column field="f" title=""></vxe-column>
							<vxe-column field="g" title=""></vxe-column>
							<vxe-column field="h" title=""></vxe-column>
						</vxe-table>
						<vxe-table border :data="tableData" size="mini" :header-cell-class-name="headerCellClassName"
							style="width: 100%;">
							<vxe-column type="seq" width="50"></vxe-column>
							<vxe-column field="goodscode" title="商品编码" width="100"></vxe-column>
							<vxe-column field="goodsname" title="商品名称"></vxe-column>
							<vxe-column field="goodsmodel" title="规格"></vxe-column>
							<vxe-column field="num" title="数量"></vxe-column>
							<vxe-column field="goodsunit" title="单位">
								<template #default="{row}">{{getEmunValue('unit',row.goodsunit)}}</template>
							</vxe-column>
							<vxe-column field="taxfreight" title="单价"></vxe-column>
							<vxe-column field="amount" title="金额小计"></vxe-column>
							<vxe-column field="mark" title="产品备注"></vxe-column>
						</vxe-table>
						<vxe-table border :data="resData" size="mini" :show-header="false"
							style="width: 100%;margin-top: 10px;">
							<vxe-column field="a" title="ERP编码"></vxe-column>
							<vxe-column field="b" title="商品名称"></vxe-column>
							<vxe-column field="c" title="规格"></vxe-column>
							<vxe-column field="d" title="数量"></vxe-column>
							<vxe-column field="e" title="数量"></vxe-column>
							<vxe-column field="f" title="单位"></vxe-column>
						</vxe-table>
						<vxe-table border :data="collectionData" size="mini" :header-cell-class-name="headerCellClassName"
							style="width: 450px;margin-top: 20px;">
							<vxe-column type="seq" width="50"></vxe-column>
							<vxe-column field="collectionaccount" title="付款账户" width="200">
								<template #default="{row}">{{getEmunValue('collectionaccount',row.collectionaccount)}}</template>
							</vxe-column>
							<vxe-column field="amount" title="付款金额" width="100"></vxe-column>
							<vxe-column field="invoiceattr" title="发票类型" width="100">
								<template #default="{row}">{{getEmunValue('invoiceattr',row.invoiceattr)}}</template>
							</vxe-column>
						</vxe-table>
						<div class="body_part2">
							<div>订单备注：{{mark}}</div>
							<div style="margin-top: 20px;font-weight: bold;">付款条件：全额付款后，标准件产品默认72小时内发货</div>
						</div>
						<div class="body_part3">
							<div>所属公司：{{company}} </div>
							<div style="margin-top: 10px;">公司地址：{{companyaddress}}</div>
							<div style="margin-top: 10px;">客服电话：{{staffphone}}</div>
							<div style="margin-top: 10px;">上级主管电话：
								<span v-for="(item,index) in director" :key="index"
									style="margin-right: 10px;">{{item.phone}} <span
										v-if="index<(director.length-1)">,</span></span>
							</div>
							<div style="margin-top: 10px;">投诉热线：18815188896</div>
						</div>
<!-- 						<div class="body_part4">
							<div>付款账户：温州纳智紧固件有限公司 </div>
						</div> -->
					</div>
				</div>
			</div>
		</div>




	</div>
</template>
<style scoped>
	.header {
		position: relative;
		width: 100%;
		color: white;
		background-color: black;
		top: 0;
		flex-direction: row;
		align-items: center;
		box-sizing: border-box;
		padding: 4px 0;
	}

	.header_notice {
		font-size: 14px;
		margin-right: 40px;
	}

	.header_title {
		font-size: 30px;
		font-weight: bold;
		flex: 1;
		text-align: center;
	}

	.body_part2 {
		font-size: 14px;
		box-sizing: border-box;
		padding: 10px;
		border-bottom: 1px solid black;
	}

	.body_part3 {
		font-size: 14px;
		box-sizing: border-box;
		padding: 10px;
		border-bottom: 1px solid black;
	}

	.body_part4 {
		font-size: 14px;
		box-sizing: border-box;
		padding: 10px;
	}
</style>
<style>
	.print-col-black {
		background-color: black;
		color: #fff;

	}
</style>
<script>
	import html2canvas from 'html2canvas';
	export default {
		props: {
			id: {
				type: Number,
				default: () => {
					return 0
				}
			},
			mainForm: {
				default: () => {
					return null
				}
			},
			name: {
				type: String,
				default: () => {
					return 0
				}
			},
		},
		data() {
			return {
				printObj: {
					id: "print_content", // 这里是要打印元素的ID
					popTitle: "&nbsp", // 打印的标题
					extraCss: '', // 打印可引入外部的一个 css 文件
					extraHead: "", // 打印头部文字
					preview: false,
					previewTitle: '报价单预览'
				},
				company:'',
				companyaddress : '',
				mark: '',
				staffphone: '',
				director: [],
				tableData: [],
				collectionData:[],
				infoData: [{
						id: 1,
						a: '报价单编号',
						b: '',
						c: '',
						d: '销售姓名',
						e: '',
						f: '报价日期',
						g: '',
						h: ''
					},
					{
						id: 2,
						a: '客户ID',
						b: '',
						c: '客户公司',
						d: '',
						e: '',
						f: '手机号',
						g: ''
					},
					{
						id: 3,
						a: '客户地址',
						b: '',
						c: '',
						d: '',
						e: '',
						f: '',
						g: '有效期',
						h: '10天'
					},
				],
				resData: [{
					id: 1,
					a: '总重量',
					b: '',
					c: '总数量',
					d: '',
					e: '总计金额',
					f: ''
				}, {
					id: 2,
					a: '快递',
					b: '',
					// c: '专票/普票/现金',
					// d: ''
				}],
				mergeCells: [{
						row: 0,
						col: 1,
						rowspan: 1,
						colspan: 2
					},
					{
						row: 0,
						col: 6,
						rowspan: 1,
						colspan: 2
					},
					{
						row: 1,
						col: 3,
						rowspan: 1,
						colspan: 2
					},
					{
						row: 1,
						col: 6,
						rowspan: 1,
						colspan: 2
					},
					{
						row: 2,
						col: 1,
						rowspan: 1,
						colspan: 5
					},
				]
			}
		},
		created() {
			this.init()
		},
		mounted() {


		},
		watch: {

		},
		computed: {

		},

		methods: {
			getEmunValue(field, value) {
				return window.systemMethods.getEmunValue(field, value)
			},
			init() {
				
				this.mainData = this.mainForm.fApi.formData()
				this.tableData = this.mainForm.fApi.el('$son_saleorder_goods').store.table.getTableData().fullData
				this.mark = this.mainData.mark
				this.infoData[0].b = this.mainData.code

				this.infoData[0].g = window.systemMethods.timestampToDate(this.mainData.commit_time)
				this.infoData[1].b = this.mainData.customername
				this.infoData[1].d = this.mainData.customercompany
				this.infoData[1].g = this.mainData.customerphone
				this.infoData[2].b = this.mainData.customeraddress


				this.resData[0].b = this.mainData.weight
				this.resData[0].d = this.mainData.num
				this.resData[0].f = this.mainData.price
				this.resData[1].b = this.mainData.delivery
				this.resData[1].d = window.systemMethods.getEmunValue('invoiceattr', this.mainData.invoiceattr)

				this.$api.staff.getdetail(this.mainData.staffid).then((res) => {
					this.infoData[0].e = res.name
					this.staffphone = res.phone
					this.director = res.director
					this.company = res.departmentParent[0].name
					this.companyaddress = res.departmentParent[0].address
				})
				this.collectionData = this.mainForm.fApi.el('$son_saleorder_collection').getTableData().fullData

				
			},
			headerCellClassName() {
				return 'print-col-black'
			},
			download() {
				html2canvas(this.$refs.printContent).then((canvas) => {
					this.convertCanvasToImg(canvas)
				})
			},
			convertCanvasToImg(canvas) {
				let myBlob = this.dataURLtoBlob(canvas.toDataURL('img/png', 0.92))
				let myUrl = URL.createObjectURL(myBlob)
				this.downImg(myUrl)
			},
			dataURLtoBlob(dataurl) {
				let arr = dataurl.split(','),
					mime = arr[0].match(/:(.*?);/)[1],
					bstr = atob(arr[1]),
					n = bstr.length,
					u8arr = new Uint8Array(n);
				while (n--) {
					u8arr[n] = bstr.charCodeAt(n);
				}
				return new Blob([u8arr], {
					type: mime
				});
			},
			downImg(url) {
				let a = document.createElement("a")
				let clickEvent = document.createEvent("MouseEvents")
				a.setAttribute("href", url)
				a.setAttribute("download", "报价单")
				a.setAttribute("target", '_blank')
				clickEvent.initEvent('click', true, true)
				a.dispatchEvent(clickEvent)
			},
			back() {
				this.$emit('back')
			}
		},
		components: {

		}
	}
</script>
